import { api } from './api'
import { currentDateTime } from './currentDateTime'

export const saveHistoryAccess = async (
  idUser,
  pageName,
  typeAccess,
  logoutSystem,
  limitCredit,
) => {
  return new Promise((resolve, reject) => {
    const auxCurrentDateTime = currentDateTime()
    const objUser = {
      idUser,
      dateLogin: typeAccess === 'login' ? auxCurrentDateTime : '',
      dateLogout: typeAccess === 'logout' ? auxCurrentDateTime : '',
      dateAccessPage: typeAccess === 'system' ? auxCurrentDateTime : '',
      dscAccessPage: pageName,
      limitCredit,
    }
    const token = localStorage.getItem('token')
    const headers = {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    }

    api
      .post(`/user/history-access/`, objUser, { headers })
      .then((response) => {
        if (response) resolve(response.data)
      })
      .catch((err) => {
        console.log('ERROR(saveHistoryAccess): ', err)
        if (err.response.data.error !== undefined && err.response.data.error === 'Invalid token!') {
          localStorage.removeItem('token')
          localStorage.removeItem('persist')
          window.location.reload(true)
          // logoutSystem('')
        } else {
          reject(err)
        }
      })
  })
}
